export const AppModalActionType = {
    OPEN_LOGIN_MODAL: 'OPEN_LOGIN_MODAL',
    OPEN_OTP_MODAL: 'OPEN_OTP_MODAL',
    OPEN_SSO_MODAL: 'OPEN_SSO_MODAL',
    OPEN_NO_ACCOUNT_FOUND_MODAL: 'OPEN_NO_ACCOUNT_FOUND_MODAL',
    OPEN_ERROR_MODAL: 'OPEN_ERROR_MODAL',
    OPEN_OTP_MODAL_V2: 'OPEN_OTP_MODAL_V2',
    CLOSE_MODAL: 'CLOSE_MODAL',
    RESET_MODAL: 'RESET_MODAL',
    OPEN_RETRY_MODAL: 'OPEN_RETRY_MODAL',
    SET_ERROR_MODAL_CALLBACK: 'SET_ERROR_MODAL_CALLBACK'
}